import { PartnerTicketUpdatesDto } from "mock-api/src/managed-receiving-global/types-v2";
import { TicketCountsSite } from "src/app/core/ticket-counts/ticket-counts-site.model";
import { UUID } from "src/utils";

export class TicketCountsPartner {
  private constructor(args: ClassProperties<TicketCountsPartner>) {
    this.partnerKey = args.partnerKey;
    this.partnerName = args.partnerName;
    this.totalCount = args.totalCount;
    this.totalOpenTicketsCount = args.totalOpenTicketsCount;
    this.totalUnassignedTicketsCount = args.totalUnassignedTicketsCount;
    this.totalYourTicketsCount = args.totalYourTicketsCount;
    this.totalAutoApprovedReservationsCount =
      args.totalAutoApprovedReservationsCount;
    this.sites = args.sites;
  }

  public readonly partnerKey: UUID;
  public readonly partnerName: string;
  public readonly totalCount: number;
  public readonly totalOpenTicketsCount: number;
  public readonly totalUnassignedTicketsCount: number;
  public readonly totalYourTicketsCount: number;
  public readonly totalAutoApprovedReservationsCount: number;
  public readonly sites: readonly TicketCountsSite[];

  public static deserialize(
    apiModel: PartnerTicketUpdatesDto,
  ): TicketCountsPartner {
    return new TicketCountsPartner({
      partnerKey: new UUID(apiModel.partnerKey),
      partnerName: apiModel.partnerName,
      sites: TicketCountsSite.deserializeList(apiModel.sites),
      totalAutoApprovedReservationsCount:
        apiModel.totalAutoApprovedReservationsCount,
      totalCount: apiModel.totalCount,
      totalOpenTicketsCount: apiModel.totalOpenTicketsCount,
      totalUnassignedTicketsCount: apiModel.totalUnassignedTicketsCount,
      totalYourTicketsCount: apiModel.totalYourTicketsCount,
    });
  }

  public static deserializeList(
    apiModel: readonly PartnerTicketUpdatesDto[],
  ): readonly TicketCountsPartner[] {
    return apiModel.map(TicketCountsPartner.deserialize);
  }
}
